/*

FILE: links.js
DESCRIPTION: Handle link functionality
AUTHOR(S): R.J. LaCount

*/

import { elements } from './elements';

const linkClicked = (e) => {
	const target = e.target;
}

const showTriggerClicked = (e) => {
	const target = e.target;
	elements.showEls.forEach(el => {
		el.dataset.show === target.dataset.trigger ? el.classList.remove('hidden') : el.classList.add('hidden');
	});
	elements.showTriggers.forEach(el => {
		el.classList.remove('active');
	});
	target.classList.add('active');
}

export { linkClicked, showTriggerClicked }
